import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M49.951 65.845c13.961 0 24.9-13.287 24.9-30.252C74.849 18.654 63.7 4.875 50 4.875S25.151 18.654 25.151 35.593c0 16.965 10.893 30.252 24.8 30.252zM50 10.007c10.872 0 19.716 11.479 19.716 25.586 0 13.852-8.867 25.12-19.765 25.12-11.028 0-19.667-11.035-19.667-25.12 0-14.107 8.844-25.586 19.716-25.586zM94.463 86.96v5.6a2.565 2.565 0 0 1-2.563 2.565H8.1a2.565 2.565 0 0 1-2.567-2.566v-5.6a2.591 2.591 0 0 1 .048-.493C6.333 74.294 15.922 66.8 30.989 66.8a2.567 2.567 0 1 1 0 5.133c-4.767 0-20.319 1.16-20.319 16.089v1.968h78.66v-1.965c0-14.929-15.551-16.089-20.318-16.089a2.567 2.567 0 0 1 0-5.133c15.066 0 24.655 7.491 25.4 19.664a2.591 2.591 0 0 1 .051.493z'

const IconProfile: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconProfile
